var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list-item',{attrs:{"link":"","dense":""},on:{"click":_vm.onCreateQuery}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"success","small":""}},[_vm._v("fa-plus")])],1),_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.queryTypeDefinition.definitionType)+" stellen ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }